import React, { Component } from "react"
import Helping from '../../helpers/Helping'
import { getAll } from '../../services/transaction.service'
import { connect } from 'react-redux'
import { addCurrentRoute } from '../../actions/profile_action'
import { MESSAGE, TRANSACTION, ROUTE_ACCESS, ROLE } from '../../config/index'
import { API_URL } from '../../config/urls'
import ReportModal from "../layout/reportModal"
import { GET_REDEEM, GET_TEAMS, USER_LIST } from '../../config/routes'
import Service from '../../helpers/service'

const { DOWNLOAD_START, DOWNLOAD_FAILED, DOWNLOAD_DATA_NOT_FOUND, START_DATE_ERROR, END_DATE_ERROR } = MESSAGE
class List extends Component {
    selectRef = [];
    constructor(props) {
        super(props)

        this.state = {
            buyers: [],
            redeems: [],
            url: Helping.getTradingApiUrl() + 'transactions',
            count: '',
            routeName: '',
            error_message: '',
            error_type: '',
            isLoading: false,
            btnIsDisable: false,
            total: 0,
            activePage: 1,
            limit: TRANSACTION.LIMIT,
            search: '',
            status: '',
            startDate: '',
            endDate: '',
            payment_type: '',
            blockchain: '',
            buyerName: '',
            code: '',
            username: '',
            type: '',
            sorting: 'id',
            sort_type: 'DESC',
            currentUser: '',
            walletHistory: [],
            slideModal: false,
            confirmedFilter: '',
            data: {}
        }

        this.handleValueChange = this.handleValueChange.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleMultiSelect = this.handleMultiSelect.bind(this)
        this.pageRefreshFunction = this.pageRefreshFunction.bind(this)
        this.onChangeStartDate = this.onChangeStartDate.bind(this)
        this.onChangeEndDate = this.onChangeEndDate.bind(this)
        this.fillData = this.fillData.bind(this)
        this.closeModal = this.closeModal.bind(this)

    }

    fillData(data) {
        this.setState({ data, slideModal: true })
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }

    componentDidMount() {
        const { pathname } = this.props.location
        this.setState({
            routeName: pathname
        })

        this.props.addCurrentRoute(this.props.profile, pathname)
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest(), ...Helping.clearDateRequest() })
    }

    getTransactions = () => {
        this.props.getAll(this.state.activePage, this.state.limit, this.state.sorting, this.state.sort_type, this.state.buyerName, this.state.payment_type, this.state.status, this.state.type, this.state.blockchain, this.state.startDate, this.state.endDate);
    }

    getRedeems() {
        let { sort_type, sorting, search } = this.state,
            body = {
                "action": "list",
                "limit": 5,
                "page": 1,
                "sort_type": sort_type,
                "sorting": sorting,
                "search": search.trim(),
                "type": "",
                "startDate": "",
                "endDate": ""
            };

        Service.postCall(API_URL.ADMIN_TRADING_API + GET_REDEEM, body).then(response => {
            this.setRedeemFilterArray(response.data.payload.redemptionCodes)
        })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                }
            })
    }

    getUsers(role = "user") {
        let search = this.state.username;

        Service.getCall(
            API_URL.ADMIN_API + USER_LIST +
            "?page=1" +
            "&limit=5" +
            "&search=" +
            search.trim() +
            "&sorting=" +
            this.state.sorting +
            "&sort_type=" +
            this.state.sort_type +
            "&startDate=" +
            "&endDate=" +
            "&role=" + role
        )
            .then(response => {
                this.setUsersFilterArray(response.data.payload.users)
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                }
            })
    }

    setUsersFilterArray(usersarray) {
        let newArray = []
        usersarray.map((item) => { newArray.push({ name: item.username, id: item.id, description: `<b style="color:#fff">${item.username}</b></br>${item.firstName} ${item.lastName}` }) })
        this.setState({
            data: { ...this.state.data, dataArray: newArray },
            buyers: newArray
        })
    }

    setRedeemFilterArray(redeemarray) {
        let newArray = []
        redeemarray.map((redeem) => { newArray.push({ name: redeem.code, id: redeem.id, description: `<b style="color:#fff">${redeem.code}</b></br>${redeem.description ? redeem.description : ""}` }) })
        this.setState({
            data: { ...this.state.data, dataArray: newArray },
            redeems: newArray,
        })
    }

    onChangeStartDate(e) {
        const date = e.target.value

        if (!this.state.endDate || this.state.endDate >= date)
            this.setState({ startDate: date, data: { ...this.state.data, startDate: date } })
        else {
            this.setState({
                startdate_message: Helping.getMessageString(START_DATE_ERROR, '')
            })
        }
    }

    onChangeEndDate(e) {
        const date = e.target.value

        if (!this.state.startDate || date >= this.state.startDate)
            this.setState({ endDate: date, data: { ...this.state.data, endDate: date } })
        else {
            this.setState({
                enddate_message: Helping.getMessageString(END_DATE_ERROR, '')
            })
        }
    }

    handleValueChange(e) {
        const { name, value } = e.target
        this.setState({
            [name]: value,
            data: { ...this.state.data, [name]: value }
        })
    }

    handleMultiSelect(data, name) {
        const result = data ? data.map(({ value }) => value) : "";

        this.setState({
            [name]: result.toString(),
            data: { ...this.state.data, [name]: result.toString() }
        });
    }

    handleSearchChange(e) {
        let searchValue = e.target.value.replace(/^\s+/g, '')

        this.setState({
            search: searchValue,
            data: { ...this.state.data, search: searchValue }
        })
    }

    handleUsersSearch = (string) => {
        this.setState({ username: string, data: { ...this.state.data, value: string } }, () => {
            this.getUsers();
        })
    }

    handleAdminsSearch = (string) => {
        this.setState({ username: string, data: { ...this.state.data, value: string } }, () => {
            this.getUsers("admin");
        })
    }

    handleRedeemsSearch = (string) => {
        this.setState({ search: string }, () => {
            this.getRedeems();
        })
    }

    handleOnSelect = (item, field) => {
        this.setState({
            [field]: item.name,
            data: { ...this.state.data, value: item.name }
        })
    }

    handleOnClear = (field) => {
        this.setState({
            [field]: '',
            data: { ...this.state.data, value: '' }
        })
    }

    formatResult = (item) => {
        return (<p dangerouslySetInnerHTML={{ __html: item }}></p>);
    }

    getUrl = (name) => {
        if (name === "users")
            return `users-csv?sorting=${this.state.sorting}&sort_type=${this.state.sort_type}&isEnable=${this.state.status}&isConfirmed=${this.state.confirmedFilter}&search=&username=${this.state.username}&startDate=${Helping.formatDateInYearMonthDay(this.state.startDate)}&endDate=${Helping.formatDateInYearMonthDay(this.state.endDate)}`;

        else if (name === "admins")
            return `users-csv?role=admin&sorting=${this.state.sorting}&sort_type=${this.state.sort_type}&isEnable=${this.state.status}&isConfirmed=${this.state.confirmedFilter}&search=${this.state.username}&startDate=${Helping.formatDateInYearMonthDay(this.state.startDate)}&endDate=${Helping.formatDateInYearMonthDay(this.state.endDate)}`;

        else if (name === "transactions")
            return `transactions-csv?sorting=${this.state.sorting}&sort_type=${this.state.sort_type}&buyerName=${this.state.buyerName}&payment_type=${this.state.payment_type}&status=${this.state.status}&type=${this.state.type}&which_bc=${this.state.blockchain}&startDate=${this.state.startDate !== "" ? Helping.formatDateInYearMonthDay(this.state.startDate) : this.state.startDate}&endDate=${this.state.endDate !== "" ? Helping.formatDateInYearMonthDay(this.state.endDate) : this.state.endDate} `;

        else if (name === "redeems")
            return {
                url: API_URL.ADMIN_TRADING_API + GET_REDEEM,
                data: {
                    "action": "redemption-csv",
                    "search": this.state.search,
                    "sorting": this.state.sorting,
                    "sort_type": this.state.sort_type,
                    "startDate": Helping.formatDateInYearMonthDay(this.state.startDate),
                    "endDate": Helping.formatDateInYearMonthDay(this.state.endDate),
                    "type": this.state.type
                }
            }
        else if (name === "free-nft")
            return {
                url: API_URL.ADMIN_API + GET_TEAMS,
                data: {
                    "action": "get_team_reward_csv"
                }
            }
    }

    getdownloadReport = (reportName) => {
        const downloadButton = document.getElementById("downloadReportButton")
        const url = this.getUrl(reportName);

        this.setState({ btnIsDisable: true })

        Service.getCall(API_URL.ADMIN_TRADING_API + url).then(response => {
            if (response.status === 200) {
                this.setState({
                    downloadUrl: response.data.payload.url,
                    error_message: Helping.getMessageString(DOWNLOAD_START, `Report`),
                    error_type: "success",
                    btnIsDisable: false
                },
                    () => { downloadButton.click(); this.scrollToTop() }
                )
            }
        }).catch(error => {
            console.log("Error ", error.response)
            this.setState({
                error_message: (error.response.data.message && error.response.data.message.includes('not found')) ? Helping.getMessageString(DOWNLOAD_DATA_NOT_FOUND, 'Report') : error.response.data.message,
                error_type: "danger",
                btnIsDisable: false
            },
                () => { this.scrollToTop() }
            )
        })
    }

    postdownloadReport = (reportName) => {
        this.setState({ btnIsDisable: true })

        const downloadButton = document.getElementById("downloadReportButton")
        const { url, data } = this.getUrl(reportName);

        Service.postCall(url, data).then(response => {
            if (response.status === 200) {
                this.setState({
                    error_message: Helping.getMessageString(DOWNLOAD_START, `Report`),
                    error_type: "success",
                    downloadUrl: response.data.payload.url,
                    btnIsDisable: false
                },
                    () => { downloadButton.click(); this.scrollToTop() }
                )
            }
        }).catch(error => {
            console.log({ error })
            this.setState({
                error_message: (error.response.data.message && error.response.data.message.includes('not found')) ? Helping.getMessageString(DOWNLOAD_DATA_NOT_FOUND, 'Report') : Helping.getMessageString(DOWNLOAD_FAILED, `Report`),
                error_type: "danger",
                btnIsDisable: false
            },
                () => { this.scrollToTop() }
            )
        })
    }

    closeModal = (e) => {
        this.setState({ slideModal: false, data: [] }, () => {
            this.selectRef = [];
            this.pageRefreshFunction(e);
            this.removeNetworkError()
        })
    }

    pageRefreshFunction(e) {
        e.preventDefault()

        this.setState({
            search: "",
            status: "",
            type: "",
            payment_type: "",
            blockchain: "",
            buyerName: "",
            startDate: "",
            endDate: "",
            confirmedFilter: '',
            redeems: [],
            buyers: [],
            username: "",
            activePage: 1,
            data: {
                ...this.state.data,
                search: "",
                status: "",
                type: "",
                payment_type: "",
                blockchain: "",
                buyerName: "",
                startDate: "",
                endDate: "",
                confirmedFilter: '',
                value: "",
                dataArray: []
            }
        }, () => {
            this.clearSelectFilter()
        })
    }

    refCallback = (name, val) => {
        const index = this.selectRef.findIndex((element) => Object.keys(element).toString() === name)

        if (index < 0) {
            const obj = {}
            obj[name] = val
            this.selectRef.push(obj)
        }
        else {
            if (val)
                this.selectRef[index][name] = val
        }
    }

    clearSelectFilter = () => {
        if (this.selectRef) {
            this.selectRef.map((ref, i) => {
                const key = Object.keys(ref).toString()

                ref[key].select.clearValue()
            })
        }
    }

    render() {
        let role_access = {}, isAdmin = false
        const allReports = [
            {
                id: 1,
                name: 'MARKET PLACE USERS',
                data: {
                    searchTitle: 'Market Place User',
                    autocomplete: true,
                    autocompleteLabel: 'Users',
                    resetBtn: true,
                    title: 'MARKET PLACE USERS',
                    status: this.state.status,
                    statusData: [{ "name": 'Active', "value": 1 }, { "name": 'Disabled', "value": 0 }],
                    confirmedFilter: this.state.confirmedFilter,
                    confirmedData: [{ "name": 'Yes', "value": 1 }, { "name": 'No', "value": 0 }],
                    dataArray: this.state.buyers,
                    value: this.state.username,
                    field: "username",
                    enable_date: true,
                    startDate: this.state.startDate,
                    handleStartDateChange: this.onChangeStartDate,
                    endDate: this.state.endDate,
                    handleEndDateChange: this.onChangeEndDate,
                    maxDate: Helping.currentDate(),
                    handleValueChange: this.handleValueChange,
                    reset: this.pageRefreshFunction,
                    handleOnSearch: this.handleUsersSearch,
                    handleOnClear: this.handleOnClear,
                    handleOnSelect: this.handleOnSelect,
                    formatResult: this.formatResult,
                    getResults: this.getdownloadReport,
                    reportName: "users"
                }

            },
            {
                id: 2,
                name: 'ADMIN USERS',
                data: {
                    searchTitle: 'Admin User',
                    autocomplete: true,
                    autocompleteLabel: 'Admin User',
                    dataArray: this.state.buyers,
                    value: this.state.username,
                    field: "username",
                    resetBtn: true,
                    title: 'ADMIN USERS',
                    status: this.state.status,
                    statusData: [{ "name": 'Active', "value": 1 }, { "name": 'Disabled', "value": 0 }],
                    confirmedFilter: this.state.confirmedFilter,
                    confirmedData: [{ "name": 'Yes', "value": 1 }, { "name": 'No', "value": 0 }],
                    enable_date: true,
                    startDate: this.state.startDate,
                    handleStartDateChange: this.onChangeStartDate,
                    endDate: this.state.endDate,
                    maxDate: Helping.currentDate(),
                    handleEndDateChange: this.onChangeEndDate,
                    handleValueChange: this.handleValueChange,
                    reset: this.pageRefreshFunction,
                    handleOnSearch: this.handleAdminsSearch,
                    handleOnClear: this.handleOnClear,
                    handleOnSelect: this.handleOnSelect,
                    formatResult: this.formatResult,
                    getResults: this.getdownloadReport,
                    reset: this.pageRefreshFunction,
                    getResults: this.getdownloadReport,
                    reportName: "admins"
                }
            },
            {
                id: 3,
                name: 'TRANSACTIONS',
                data: {
                    resetBtn: true,
                    title: 'TRANSACTIONS',
                    enable_date: true,
                    startDate: this.state.startDate,
                    handleStartDateChange: this.onChangeStartDate,
                    endDate: this.state.endDate,
                    handleEndDateChange: this.onChangeEndDate,
                    status: this.state.status,
                    statusData: [{ "label": 'Pending', "value": 'pending' }, { "label": 'Processing', "value": 'processing' }, { "label": 'Confirmed', "value": 'confirmed' }, { "label": 'Failed', "value": 'failed' }],
                    type: this.state.type,
                    typeData: [{ "label": 'Sale', "value": 'sale' }, { "label": 'Gift', "value": 'gift' }, { "label": 'Trade', "value": 'trade' }, { "label": 'Offer', "value": 'offer' }, { "label": 'Auction', "value": 'auction' }, { "label": "Offsite Sale", "value": "offsite-sale" }, { "label": "Reward", "value": "reward" }],
                    payment_type: this.state.payment_type,
                    paymentTypeData: [{ "label": 'CARD', "value": 'CARD' }, { "label": 'EXISTING CARD', "value": 'EXISTING_CARD' }, { "label": 'WALLET', "value": 'WALLET' }, { "label": 'ETH', "value": 'ETH' }, { "label": 'DEFAULT', "value": 'DEFAULT' }, { "label": 'CARD / EXISTING CARD', "value": "CARD,EXISTING_CARD" }],
                    blockchain: this.state.blockchain,
                    blockchainData: [{ "label": 'ETH', "value": 'ETH' }, { "label": 'MATIC', "value": 'MATIC' }, { "label": 'CARDANO', "value": 'CARDANO' }],
                    multiSelect: true,
                    autocomplete: true,
                    autocompleteLabel: 'Buyers',
                    dataArray: this.state.buyers,
                    value: this.state.buyerName,
                    field: "buyerName",
                    ref: this.refCallback,
                    handleValueChange: this.handleValueChange,
                    reset: this.pageRefreshFunction,
                    handleMultiSelect: this.handleMultiSelect,
                    handleOnSearch: this.handleUsersSearch,
                    handleOnClear: this.handleOnClear,
                    handleOnSelect: this.handleOnSelect,
                    formatResult: this.formatResult,
                    getResults: this.getdownloadReport,
                    reportName: "transactions"
                }
            },
            {
                id: 4,
                name: 'REDEEM',
                data: {
                    searchTitle: 'Redeem',
                    resetBtn: true,
                    title: 'REDEEM',
                    enable_date: true,
                    startDate: this.state.startDate,
                    handleStartDateChange: this.onChangeStartDate,
                    endDate: this.state.endDate,
                    handleEndDateChange: this.onChangeEndDate,
                    type: this.state.type,
                    typeData: [{ "label": 'DEFAULT', "value": 'default' }, { "label": 'CMC', "value": 'cmc' }, { "label": 'Nitro', "value": 'nitro' }, { "label": 'AscendEX', "value": 'ascendex' }, { "label": 'Cardano', "value": 'cardano' }],
                    autocomplete: true,
                    autocompleteLabel: 'Redeems',
                    dataArray: this.state.redeems,
                    value: this.state.search,
                    field: "search",
                    handleValueChange: this.handleValueChange,
                    reset: this.pageRefreshFunction,
                    handleOnSearch: this.handleRedeemsSearch,
                    handleOnClear: this.handleOnClear,
                    handleOnSelect: this.handleOnSelect,
                    formatResult: this.formatResult,
                    getResults: this.postdownloadReport,
                    reportName: "redeems"
                }
            },
            {
                id: 5,
                name: 'ISL-FREE NFT',
                data: {
                    resetBtn: false,
                    title: 'ISL-FREE NFT',
                    reset: this.pageRefreshFunction,
                    getResults: this.postdownloadReport,
                    reportName: "free-nft"
                }
            },
        ]

        if (Object.keys(this.props.profile).length > 0) {
            role_access = JSON.parse(this.props.profile.role_access)
            isAdmin = role_access.role === ROLE.ADMIN.toLowerCase()
        }
        let writeAccess = isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.TRANSACTION.toLowerCase()].write)
       
        return (
            <>
                {(this.state.slideModal && this.state.data) &&
                    <>
                        <ReportModal data={this.state.data} closeModal={this.closeModal} removeNetworkError={this.removeNetworkError} error_message={this.state.error_message} error_type={this.state.error_type} btnIsDisable={this.state.btnIsDisable} />
                    </>
                }
                <div class="content transaction-list">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">Reports</h2>
                            <span class="title-caption">You have total {allReports.length} Reports</span>
                        </div>
                    </div>
                    <a href={this.state.downloadUrl} style={{ display: "none" }} id="downloadReportButton" target="_blank" rel="noopener noreferrer" download>
                        <i className="fas fa-download" />
                        Download File
                    </a>
                    <div class="main-content" id="main_content">
                        <div class="user-listing-tbl table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="tbl-sorting" scope="col">Id</th>
                                        <th class="tbl-sorting" scope="col"></th>
                                        <th class="tbl-sorting" scope="col"></th>
                                        <th class="tbl-sorting" scope="col"></th>
                                        <th class="tbl-sorting" scope="col"></th>
                                        <th class="tbl-sorting" scope="col">Name</th>
                                        <th class="tbl-sorting" scope="col" ></th>
                                        <th class="tbl-sorting" scope="col"></th>
                                        <th class="tbl-sorting" scope="col"></th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>

                                {(allReports.length) && (
                                    <tbody>
                                        {allReports.map((report, i) => (
                                            <tr key={i}>
                                                <td scope="row">{report.id}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{report.name}</td>
                                                <td>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                    <div className="action-links">
                                                        <button
                                                            type='button'
                                                            class="icon download"
                                                            title="Download Report"
                                                            data-toggle="modal"
                                                            data-target="#downloadReport"
                                                            onClick={(e) => this.fillData(report.data, e)}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="15.5" viewBox="0 0 15.5 15.5">
                                                                <g id="import" transform="translate(0.75 0.75)">
                                                                    <path id="Path_344" data-name="Path 344" d="M4.75,14.75v1.5a2.949,2.949,0,0,0,2.9,3h8.207a2.949,2.949,0,0,0,2.9-3v-1.5" transform="translate(-4.75 -5.25)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                                    <path id="Path_345" data-name="Path 345" d="M12,14.25V4.75" transform="translate(-5 -4.75)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                                    <path id="Path_346" data-name="Path 346" d="M8.75,10.75,12,14.25l3.25-3.5" transform="translate(-5 -5.023)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.profile,
        transactions: state.transactions,
        buyers: state.buyers,
        isLoading: state.transactionsMeta.isLoading,
        page: state.transactionsMeta.page,
        limit: state.transactionsMeta.limit,
        count: state.transactionsMeta.length,
        total: state.transactionsMeta.total,
    }
}
const mapDispatchToProps = {
    getAll,
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(List)